import { REDUX_STORE } from '@funnels/constants';
import {
  ClearCompanyErrorAction,
  Company,
  CreateCompanyAction,
  CreateCompanyFailAction,
  CreateCompanySuccessAction,
  DeleteCompanyAction,
  DeleteCompanyFailAction,
  DeleteCompanySuccessAction,
  FetchCompaniesAction,
  FetchCompaniesFailAction,
  FetchCompaniesSuccessAction,
  ServerCompanyFetch,
  UpdateCompanyAction,
  UpdateCompanyFailAction,
  UpdateCompanySuccessAction,
  UpsertCompaniesAction,
  UpsertCompaniesFailAction,
  UpsertCompaniesSuccessAction,
} from '@funnels/types';

export function clearCompanyError(): ClearCompanyErrorAction {
  return { type: REDUX_STORE.COMPANIES.ACTION_TYPES.CLEAR_COMPANY_ERROR };
}

export function createCompany(applicationId: string, company: Company): CreateCompanyAction {
  return {
    type: REDUX_STORE.COMPANIES.ACTION_TYPES.CREATE_COMPANY,
    applicationId,
    company,
  };
}

export function createCompanyFail(clientId: string, message: string = 'Unknown error'): CreateCompanyFailAction {
  return { type: REDUX_STORE.COMPANIES.ACTION_TYPES.CREATE_COMPANY_FAIL, clientId, message };
}

export function createCompanySuccess(clientId: string, id: string): CreateCompanySuccessAction {
  return { type: REDUX_STORE.COMPANIES.ACTION_TYPES.CREATE_COMPANY_SUCCESS, clientId, id };
}

export function deleteCompany(applicationId: string, clientId: string): DeleteCompanyAction {
  return {
    type: REDUX_STORE.COMPANIES.ACTION_TYPES.DELETE_COMPANY,
    applicationId,
    clientId,
  };
}

export function deleteCompanyFail(clientId: string, message: string = 'Unknown error'): DeleteCompanyFailAction {
  return { type: REDUX_STORE.COMPANIES.ACTION_TYPES.DELETE_COMPANY_FAIL, clientId, message };
}

export function deleteCompanySuccess(): DeleteCompanySuccessAction {
  return { type: REDUX_STORE.COMPANIES.ACTION_TYPES.DELETE_COMPANY_SUCCESS };
}

export function fetchCompanies(applicationId: string, clientId?: string): FetchCompaniesAction {
  return { type: REDUX_STORE.COMPANIES.ACTION_TYPES.FETCH_COMPANIES, applicationId, clientId };
}

export function fetchCompaniesFail(message: string = 'Unknown error'): FetchCompaniesFailAction {
  return { type: REDUX_STORE.COMPANIES.ACTION_TYPES.FETCH_COMPANIES_FAIL, message };
}

export function fetchCompaniesSuccess(companies: ServerCompanyFetch[]): FetchCompaniesSuccessAction {
  return {
    type: REDUX_STORE.COMPANIES.ACTION_TYPES.FETCH_COMPANIES_SUCCESS,
    companies,
  };
}

export function updateCompany(applicationId: string, company: Company): UpdateCompanyAction {
  return {
    type: REDUX_STORE.COMPANIES.ACTION_TYPES.UPDATE_COMPANY,
    applicationId,
    company,
  };
}

export function updateCompanyFail(clientId: string, message: string = 'Unknown error'): UpdateCompanyFailAction {
  return { type: REDUX_STORE.COMPANIES.ACTION_TYPES.UPDATE_COMPANY_FAIL, clientId, message };
}

export function updateCompanySuccess(): UpdateCompanySuccessAction {
  return { type: REDUX_STORE.COMPANIES.ACTION_TYPES.UPDATE_COMPANY_SUCCESS };
}

export function upsertCompanies(applicationId: string, companies: Company[]): UpsertCompaniesAction {
  return {
    type: REDUX_STORE.COMPANIES.ACTION_TYPES.UPSERT_COMPANIES,
    applicationId,
    companies,
  };
}

export function upsertCompaniesFail(message: string): UpsertCompaniesFailAction {
  return { type: REDUX_STORE.COMPANIES.ACTION_TYPES.UPSERT_COMPANIES_FAIL, message };
}

export function upsertCompaniesSuccess(): UpsertCompaniesSuccessAction {
  return { type: REDUX_STORE.COMPANIES.ACTION_TYPES.UPSERT_COMPANIES_SUCCESS };
}
